import { environment } from '@env/environment';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { get, isArray, isPlainObject, forEach } from 'lodash';
import { SeoService } from './seo.service';
import * as i0 from "@angular/core";
import * as i1 from "ngx-toastr";
import * as i2 from "@ngx-translate/core";
import * as i3 from "./seo.service";
var HelpersService = /** @class */ (function () {
    function HelpersService(toastr, translate, seo) {
        this.toastr = toastr;
        this.translate = translate;
        this.seo = seo;
        this.urlRegex = new RegExp(/^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/);
    }
    /**
   * Display toastr error
   * @param error Custom Error Object
   * @param toastrOptions Overwrite default toastr options
   */
    HelpersService.prototype.errorMessage = function (error, toastrOptions) {
        var _this = this;
        var message = get(error, 'error.error.userMessage') ||
            get(error, 'error.error.errorMessage') ||
            get(error, 'errorMessage') ||
            get(error, 'error.errors') ||
            get(error, 'userMessage') ||
            get(error, 'errorMessage') ||
            get(error, 'message') ||
            this.translate.instant('generic-error');
        if (isPlainObject(message)) {
            forEach(message, function (val, key) {
                if (isArray(val)) {
                    val.forEach(function (msg) {
                        _this.toastr.error(msg, 'Error', toastrOptions);
                    });
                }
                else {
                    _this.toastr.error(val, 'Error', toastrOptions);
                }
            });
            return;
        }
        if (isArray(message)) {
            message.forEach(function (item) {
                var msg = get(item, 'errorMessage');
                _this.toastr.error(msg, 'Error', toastrOptions);
            });
            return;
        }
        this.toastr.info(message, 'Error', toastrOptions);
    };
    /**
    * Show warning toastr
    * @param message warning message
    * @param title  warning title
    * @param toastrOptions Overwrite default toastr options
    */
    HelpersService.prototype.warningMessage = function (message, title, toastrOptions) {
        return this.toastr.info(message, title ? title : '', toastrOptions);
    };
    /**
    * Show success toastr
    * @param message success message
    * @param title  success title
    * @param toastrOptions Overwrite default toastr options
    */
    HelpersService.prototype.successMessage = function (message, title, toastrOptions) {
        return this.toastr.success(message, title ? title : '', toastrOptions);
    };
    /**
    * Show info toastr
    * @param message success message
    * @param title  success title
    * @param toastrOptions Overwrite default toastr options
    */
    HelpersService.prototype.infoMessage = function (message, title, toastrOptions) {
        return this.toastr.info(message, title ? title : '', toastrOptions);
    };
    /**
     * Get a langs regex to validate browser lang
     */
    HelpersService.prototype.getLangRegex = function () {
        var langs = environment.langs ? environment.langs.join('|') : environment.defaults.lang;
        var regex = new RegExp(langs);
        return regex;
    };
    /**
     * Generate query string for HTTP get requests
     * @param payload options
     */
    HelpersService.prototype.queryOptions = function (payload) {
        var params = '';
        var keys = Object.keys(payload);
        // concat all parameters
        keys.forEach(function (key) {
            if (!params.length) {
                params = payload[key] ? "?" + key + "=" + payload[key] : "&" + key;
            }
            else {
                params += payload[key] ? "&" + key + "=" + payload[key] : "&" + key;
            }
        });
        return params;
    };
    HelpersService.prototype.setformAsValid = function (form) {
        var keys = Object.keys(form.controls);
        keys.forEach(function (key) {
            if (form.controls[key]) {
                form.controls[key].markAsTouched();
                form.controls[key].setErrors(null);
            }
        });
    };
    HelpersService.prototype.setFormError = function (form, valid) {
        var keys = Object.keys(form.controls);
        keys.forEach(function (key) {
            if (form.controls[key]) {
                form.controls[key].markAsTouched();
                form.controls[key].setErrors({ valid: valid || false, submitted: true });
            }
        });
    };
    HelpersService.prototype.displayFormErrors = function (form, messages) {
        var _this = this;
        if (messages === void 0) { messages = []; }
        var keys = Object.keys(form.controls);
        var childFormKey = keys.find(function (key) { return form.controls[key] instanceof FormGroup; });
        keys.forEach(function (key) {
            var message = _this.findMessage(messages, key);
            if (form.controls[key] && !form.controls[key].valid) {
                form.controls[key].markAsTouched();
                form.controls[key].setErrors({
                    valid: false,
                    submitted: true,
                    message: message
                });
            }
        });
        if (childFormKey) {
            var childKeys = Object.keys(form.controls[childFormKey]['controls']);
            var childForm_1 = form.controls[childFormKey];
            childKeys.forEach(function (key) {
                if (childForm_1.controls[key] && !childForm_1.controls[key].valid) {
                    var message = _this.findMessage(messages, key);
                    childForm_1.controls[key].markAsTouched();
                    childForm_1.controls[key].setErrors({
                        valid: false,
                        submitted: true,
                        message: message
                    });
                }
            });
        }
    };
    /**
    * Initialize translate service
    * by getting the language from browser settings
    */
    HelpersService.prototype.bootstrapLang = function () {
        // specify app languages
        this.translate.addLangs(environment.langs || []);
        // get browser languages
        var browserLang = this.translate.getBrowserLang();
        browserLang = browserLang.match(this.getLangRegex()) ? browserLang : environment.defaults.lang;
        // check in session storage for user lang if not exists use browserlang
        var userLang = localStorage.getItem('eyrus-lang') || browserLang;
        // if do not exists on session storage, set browser lang
        if (!localStorage.getItem('eyrus-lang'))
            localStorage.setItem('eyrus-lang', browserLang);
        // this language will be used as a fallback when a translation isn't found in the current language
        this.translate.setDefaultLang(environment.defaults.lang);
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        this.translate.use(userLang);
    };
    HelpersService.prototype.updateLang = function (lang) {
        localStorage.setItem('eyrus-lang', lang);
        this.bootstrapLang();
    };
    /**
     * Set meta keys provided for each section
     */
    HelpersService.prototype.setMetaKeys = function (config) {
        this.seo.generateTags(config);
    };
    HelpersService.prototype.findMessage = function (messages, key) {
        var message = '';
        message = messages.find(function (e) {
            return e.fieldName === key;
        });
        return get(message, 'errorMessage') || '';
    };
    /**
     * get lang from browser
     */
    HelpersService.prototype.getLang = function () {
        return localStorage.getItem('eyrus-lang') || 'en';
    };
    /**
     * Get images or videos files as base64 string
     * @param file
     */
    HelpersService.prototype.getMediaAsBase64 = function (file) {
        var _this = this;
        var reader = new FileReader();
        return new Promise(function (resolve, reject) {
            reader.onload = function (e) {
                resolve({ url: e.target.result, data: file });
            };
            reader.onerror = function () {
                return reject(_this);
            };
            if (file.type.indexOf('image') !== -1 || file.type.indexOf('video') !== -1) {
                reader.readAsDataURL(file);
            }
            else
                reject(file);
        });
    };
    /**
       * Device with validation
       */
    HelpersService.prototype.deviceIsMobile = function () {
        return (window.innerWidth >= 700) ? false : true;
    };
    HelpersService.ngInjectableDef = i0.defineInjectable({ factory: function HelpersService_Factory() { return new HelpersService(i0.inject(i1.ToastrService), i0.inject(i2.TranslateService), i0.inject(i3.SeoService)); }, token: HelpersService, providedIn: "root" });
    return HelpersService;
}());
export { HelpersService };
